import styled from 'styled-components';

export const BackButton = styled('div')`
	cursor: pointer;
	display: inline-block;
	color: ${props => props.theme.primary.iconsColor};

	& > svg {
		height: 30px;
		width: 10px;
		margin: -10px 0;
		padding: 0 10px;
		fill: ${props => props.theme.primary.iconsColor};
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemDetailPage/styles.ts